import { render, staticRenderFns } from "./OrderHeader.vue?vue&type=template&id=cb899846&scoped=true"
import script from "./OrderHeader.vue?vue&type=script&lang=js"
export * from "./OrderHeader.vue?vue&type=script&lang=js"
import style0 from "./OrderHeader.vue?vue&type=style&index=0&id=cb899846&prod&lang=css"
import style1 from "./OrderHeader.vue?vue&type=style&index=1&id=cb899846&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb899846",
  null
  
)

export default component.exports